/**
 * Created by Mark on 18/04/2017.
 */


import ENVIRONMENT_CONSTANTS from './environment.js'

export default {
    MAKE_CONTENT : ENVIRONMENT_CONSTANTS.BASE_URL + 'contentCreationController/makeModule',
    FETCH_CONTENT : ENVIRONMENT_CONSTANTS.BASE_URL + 'contentCreationController/fetchModules',
    FETCH_CONTENT_LANGAUGE:ENVIRONMENT_CONSTANTS.BASE_URL + 'contentCreationController/fetchModulesLanguage',
    GET_CATALOG_SUMMARY: ENVIRONMENT_CONSTANTS.BASE_URL + 'contentCreationController/fetchModuleSummary',
    ADD_VOCAB:ENVIRONMENT_CONSTANTS.BASE_URL + 'contentCreationController/addVocabItem',
    REMOVE_VOCAB:ENVIRONMENT_CONSTANTS.BASE_URL + 'contentCreationController/removeVocabItem',
    ON_MY_CONTENT_UPDATE : 'ON_MY_CONTENT_UPDATE',
    GET_CATALOG_VOCAB: ENVIRONMENT_CONSTANTS.BASE_URL + '/vocabTranslationController/getCatalogsVocabTranslations',
    ON_VOCAB_FETCH :  'ON_VOCAB_FETCH',
    ON_SUMMARY_FETCH :'ON_SUMMARY_FETCH',
    UPLOAD_AUDIO :ENVIRONMENT_CONSTANTS.BASE_URL + 'contentCreationController/uploadAudio',
    MAKE_VOCAB : ENVIRONMENT_CONSTANTS.BASE_URL +'contentCreationController/makeVocab',
    PUBLISH : ENVIRONMENT_CONSTANTS.BASE_URL +'contentCreationController/setPublished',
    UN_PUBLISH : ENVIRONMENT_CONSTANTS.BASE_URL +'contentCreationController/setUnpublished',
    ON_VERBS_FETCH : 'ON_VERBS_FETCH',
    VERBS_FETCH : ENVIRONMENT_CONSTANTS.BASE_URL +'verbTranslationController/getVerbTranslations'
}




// WEBPACK FOOTER //
// ./src/constants/content.js